export function ChatBotLayout(props) {
  return <div className='h-full'>{<props.children {...props.data} />}</div>
}
